import AuthLayout from '@/app/layout/authLayout'
import { ResetPasswordForm } from '@/app/entities/auth/ui/recovery/ResetPasswordForm'

export const ResetPasswordPage = () => {
    return (
        <AuthLayout>
            <ResetPasswordForm />
        </AuthLayout>
    )
}
